export default angular.module("mars.vet.dnareports.controllers.breedscertificate",[]).controller('BreedsCertificateController',
    function($rootScope, $scope, $window,
            EntryService, EntryIDService, ImageService, FileService, NavigationService, UtilityService,
            reportdata) {

        'ngInject';

        var resultString = reportdata.resultString;
        var sampleDetails = reportdata.sampleDetails;

        $scope.sampleID = resultString.sampleID;

        var reportType = 'online';
        $scope.onloadFun = function() {
            reportType = 'pdf';
        }

        EntryService.getEntry(EntryIDService.getEntryID('Certificate')).then(function(response) {
            var fields = response.fields;
            if (reportType != 'pdf') {
                $rootScope.pageTitle = fields.title;
            }
            $scope.title = fields.title;
            $scope.description = fields.description.replaceAll("[DOG NAME]", sampleDetails.petDetails.petName);
            var versionNo = Math.floor((Math.random() * 100) + 1);
            var printCertificatePath= "/staticresources/dnareports/images/" + resultString.sampleID + "/certificate.png";
            $scope.certificate = "/staticresources/dnareports/images/" + resultString.sampleID + "/certificate.png";
            $scope.newCertificate = "/staticresources/dnareports/images/" + resultString.sampleID + "/certificateThumbnail.png";

            $scope.fbs_click = UtilityService.fbs_click;
            $scope.instagram_click = UtilityService.instagram_click;
            $scope.twitter_click = UtilityService.twitter_click;
            $scope.pinterest_click = UtilityService.pinterest_click;
            $scope.printCertificate = UtilityService.printCertificate;
            
            ImageService.getImageUrl('7dDa5QeYwMg6oOEUKUiOoO').then(function(response) {
                $scope.fbImage = response.data.fields.file.url;
            });
            ImageService.getImageUrl('6ehEkqryM0KMui0g8GESMm').then(function(response) {
                $scope.twitterImage = response.data.fields.file.url;
            });
            ImageService.getImageUrl('5chGCl2XVmA02sEYyamyc4').then(function(response) {
                $scope.instagramImage = response.data.fields.file.url;
            });
            ImageService.getImageUrl('4TtxdL2uk0AC46wE62kCW4').then(function(response) {
                $scope.webImage = response.data.fields.file.url;
            });
            ImageService.getImageUrl('rdcaYEa0xi2YW26gGOusw').then(function(response) {
                $scope.pinterestImage = response.data.fields.file.url;
            });
            ImageService.getImageUrl('5xExMvhUk0QG8cWO2kiGM0').then(function(response) {
                $scope.certificateButton = response.data.fields.file.url;
            });
            $scope.fbicon = NavigationService.setNavigationUrls();
            $window.ga('send', 'pageview', {
                'page': $rootScope.pageTitle
            });
            

       /*     $scope.printCertificate = function() {
            	var win = window.open('');
            	win.document.write('<img src="' + printCertificatePath + '" onload="window.print();window.close()" height="150%" width="100%"/>');
            	win.focus();
            }*/

        }, function(error) {
            // promise rejected, could log the error with:
            // console.log('error', error);
        });
    }).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/controllers/breedscertificate.controller.js